import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "color", "iconId", "rotate", "size", "sx"];
import { useMemo, Suspense, forwardRef } from 'react';
import { iconImportsForInternalUseOnly } from './icons';
import Box from '@mui/material/Box';
import { jsx as _jsx } from "react/jsx-runtime";
export var Icon = /*#__PURE__*/forwardRef(function IconWrapper(_ref, ref) {
  var _ref$className = _ref.className,
    controlledClassName = _ref$className === void 0 ? '' : _ref$className,
    color = _ref.color,
    iconId = _ref.iconId,
    rotate = _ref.rotate,
    size = _ref.size,
    sx = _ref.sx,
    others = _objectWithoutProperties(_ref, _excluded);
  var SvgIcon = useMemo(function () {
    return iconImportsForInternalUseOnly[iconId];
  }, [iconId]);
  if (!SvgIcon) return null;
  var iconSize = size === undefined || size < 1 ? '24px' : "".concat(size, "px");
  return /*#__PURE__*/_jsx(Box, _extends({
    "aria-label": iconId,
    className: "zenith-icon ".concat(controlledClassName),
    ref: ref,
    role: "img",
    sx: _extends({
      alignItems: 'center',
      color: color || 'inherit',
      display: 'flex',
      fontSize: iconSize,
      height: iconSize,
      justifyContent: 'center',
      transform: rotate ? "rotate(".concat(rotate, "deg)") : undefined,
      width: iconSize
    }, sx)
  }, others, {
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: null,
      children: /*#__PURE__*/_jsx(SvgIcon, {
        color: color
      })
    })
  }));
});